import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useCreateReceivable } from "../../api/receivables";
import { useCustomers } from "../../api/customers";
import { useDebounce } from "../../hooks/useDebounce";
import { useToast } from "../../components/ToastProvider";

export function NewReceivableModal({ show, onClose }: { show: boolean; onClose: () => void }) {
  const [customerQuery, setCustomerQuery] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [reference, setReference] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [value, setValue] = useState("");
  const [error, setError] = useState<string | null>(null);

  const debouncedQuery = useDebounce(customerQuery);
  const { data: customersData } = useCustomers({ pageSize: 20, q: debouncedQuery || undefined });
  const create = useCreateReceivable();
  const toast = useToast();

  function reset() {
    setCustomerQuery("");
    setCustomerId("");
    setReference("");
    setDueDate("");
    setValue("");
    setError(null);
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!customerId) return setError("Selecione o cliente.");
    if (!reference.trim()) return setError("Informe a referência do título.");
    if (!dueDate) return setError("Informe o vencimento.");
    const numericValue = Number(value.replace(",", "."));
    if (!numericValue || numericValue <= 0) return setError("Informe um valor válido para emitir.");

    try {
      await create.mutateAsync({ customerId: Number(customerId), reference, dueDate, value: numericValue });
      toast("Título criado.");
      reset();
      onClose();
    } catch {
      setError("Não foi possível criar o título.");
    }
  }

  return (
    <Modal backdrop="static" keyboard={false} show={show} onHide={onClose} centered className="nt-dialog">
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title style={{ fontSize: 20, fontFamily: "var(--font-heading)" }}>Novo título a receber</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column gap-3">
          <div>
            <label className="form-label" style={{ fontSize: 12 }}>
              Cliente
            </label>
            <input className="form-control mb-2" placeholder="Buscar cliente…" value={customerQuery} onChange={(e) => setCustomerQuery(e.target.value)} />
            <select className="form-select" value={customerId} onChange={(e) => setCustomerId(e.target.value)}>
              <option value="">Selecione…</option>
              {customersData?.data.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.razaoSocial}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="form-label" style={{ fontSize: 12 }}>
              Referência
            </label>
            <input className="form-control" value={reference} onChange={(e) => setReference(e.target.value)} placeholder="Ex.: Implantação 2 de 3" />
          </div>
          <div className="row g-3">
            <div className="col-12 col-sm-6">
              <label className="form-label" style={{ fontSize: 12 }}>
                Vencimento
              </label>
              <input type="date" className="form-control" value={dueDate} onChange={(e) => setDueDate(e.target.value)} />
            </div>
            <div className="col-12 col-sm-6">
              <label className="form-label" style={{ fontSize: 12 }}>
                Valor (R$)
              </label>
              <input className="form-control" value={value} onChange={(e) => setValue(e.target.value)} placeholder="0,00" />
            </div>
          </div>
          {error && (
            <div className="text-danger" style={{ fontSize: 12.5 }}>
              {error}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-danger" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="btn btn-success" disabled={create.isPending}>
            Criar título
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
